import React from "react";
import { Modal } from "../../../../shared/Modal/Modal";
import { InputLabel } from "../../../../shared/InputLabel/InputLabel";
import { Input } from "../../../../shared/Input/Input";
import { Button } from "../../../../shared/Button/Button";
import styles from "../scss/UpgradeEpcsModal.module.scss";
import { useEpcsModalForm } from "../hooks/useEpcsModalForm";
import { useUpgradePrescriber } from "../hooks/useUpgradePrescriber";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { uiNotification } from "../../../../services/UINotificationService";

const UpgradeEpcsModal = ({
  onClose,
  id,
  setLocalPrescribers,
  initialFormValues,
}) => {
  const { mutate: upgradePrescriber, isLoading: isUpgrading } =
    useUpgradePrescriber();

  const handleUpgrade = (values) => {
    upgradePrescriber(
      { id, ...values },
      {
        onSuccess: (response) => {
          const updatedPrescriber = response.data.data.updated_prescriber;
          setLocalPrescribers((prev) =>
            prev.map((prescriber) =>
              prescriber.id === updatedPrescriber.id
                ? updatedPrescriber
                : prescriber,
            ),
          );
          uiNotification.success("Prescriber upgraded successfully.");
          onClose();
        },
        onError: (error) => {
          uiNotification.error(
            error?.response?.data?.message || "An error occurred.",
          );
        },
      },
    );
  };

  const { values, handleInputChange, handleSubmit, errors } = useEpcsModalForm(
    handleUpgrade,
    initialFormValues,
  );

  return (
    <Modal isOpen onClose={onClose}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>Provide information</h3>
        </div>
        <div className={styles.modalForm}>
          <div>
            <InputLabel>DEA Number</InputLabel>
            <Input
              size="small"
              name="dea"
              value={values.dea}
              onChange={handleInputChange}
              isError={Boolean(errors.dea)}
            />
          </div>
          <div>
            <InputLabel>State License Number</InputLabel>
            <Input
              size="small"
              name="licenseNumber"
              value={values.licenseNumber}
              onChange={handleInputChange}
              isError={Boolean(errors.licenseNumber)}
            />
          </div>
          <div>
            <InputLabel>NPI</InputLabel>
            <Input
              size="small"
              name="npi"
              value={values.npi}
              onChange={handleInputChange}
              isError={Boolean(errors.npi)}
            />
          </div>
        </div>
        <div className={styles.modalFooter}>
          <Button size="small" variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            onClick={handleSubmit}
            isDisabled={isUpgrading}
            leftAdornment={
              isUpgrading ? (
                <CircularProgress size="small" color="white" />
              ) : null
            }
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UpgradeEpcsModal;
